import { isIOSDevice, isMac } from '@/app/utils/browser';

export const MY_ISUZU_APP_STORE_URLS = {
  IOS: 'https://apps.apple.com/us/app/my-isuzu/id1612415578',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.tis.myisuzu',
} as const;

export const getMyIsuzuStore = () => {
  return isIOSDevice || isMac
    ? MY_ISUZU_APP_STORE_URLS.IOS
    : MY_ISUZU_APP_STORE_URLS.ANDROID;
};
